<template>
  <div>
    <div v-if="$guser.isClinic() && $guser.user.clinic && $guser.user.clinic.approved !== 1" class="card-inverse card-warning alert-top-box card-orange-warning"> 
      <div class="card-block alert-container">
        <i class="fa fa-exclamation-circle alert-sign" aria-hidden="true"></i>
        <blockquote class="card-blockquote alert-text">
          <h4 class="header-text">{{$t('message.alert_bar.title')}}</h4>
          <p>{{$t('message.alert_bar.message')}}</p>
          <p>{{$t('message.alert_bar.contact')}}</p>
        </blockquote>
      </div>
    </div>

    <div v-if="$guser.isClinic() && $guser.user.clinic && $guser.user.clinic.approved === 1 && $guser.user.clinic.sms_active && $guser.user.clinic.sms_credit < 100" class="card-inverse card-warning alert-top-box card-orange-warning"> 
      <div class="card-block alert-container">
        <i class="fa fa-exclamation-circle alert-sign" aria-hidden="true"></i>
        <blockquote class="card-blockquote alert-text">
          <h4 class="header-text">{{$t('message.alert_bar_sms_warning.title')}}</h4>
          <p>{{$t('message.alert_bar_sms_warning.message')}} {{$guser.user.clinic.sms_credit + ' Credit'}}</p>
          <p>{{$t('message.alert_bar_sms_warning.contact')}}</p>
        </blockquote>
      </div>
    </div>

    <div v-if="$guser.isDoctor() && $guser.user.doctor && $guser.user.doctor.approved !== 1" class="card-inverse card-warning alert-top-box card-orange-warning"> 
      <div class="card-block alert-container">
        <i class="fa fa-exclamation-circle alert-sign" aria-hidden="true"></i>
        <blockquote class="card-blockquote alert-text">
          <h4 class="header-text">{{$t('message.alert_bar.title')}}</h4>
          <p>{{$t('message.alert_bar.message')}} {{$t('message.alert_bar.contact')}}</p>
        </blockquote>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'alertbar'
}
</script>

<style lang="scss">
  .card-orange-warning{
    background-color: #f39c12 !important;
  }
  .card-blockquote p {
    margin-bottom: 0;
  }
  .alert-container {
    display: flex;
    justify-content: space-between;
  }
  .alert-sign {
    font-size: 4rem;
    margin-right: 1rem;
  }

  .alert-top-box {
    margin-bottom: 20px !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .alert-text .header-text {
    margin-top: 0.3rem;
    color: #fff;
  }

  .alert-text {
    flex-grow: 1;
  }

  .alert-container-padding-zero {
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// AlertBar.vue?8bd8c49a